import { PageLink, PageTitle } from "_metronic/layout/core";
import { ExternalAccessData } from "app/modules/auth";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { shallowEqual, useSelector } from "react-redux";
import { ExternalAccessCommentModel } from "services/classes/ExternalAccessCommentModel";
import { NewCommentModel } from "services/classes/NewCommentModel";
import { RootState } from "setup";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import { createExternalAccessComment, selectActionSuccessful, selectLoading } from "../ExternalAccessSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import Comment from "app/modules/shared/commentThread/components/Comment";

const externalAccessCommentBreadCrumbs: Array<PageLink> = [
  {
    title: "Comment",
    path: "/comment",
    isSeparator: false,
    isActive: true,
  },
];

const ExternalAccessCommentPage = () => {
  const externalAccessData = useSelector<RootState, ExternalAccessData | undefined>(
    ({ auth }) => auth.externalAccess,
    shallowEqual
  );
  const loading = useSelector(selectLoading);
  const actionSuccessful = useSelector(selectActionSuccessful);
  const thunkDispatch = useThunkDispatch();

  const handleCreateComment = (comment: NewCommentModel) => {
    thunkDispatch(
      createExternalAccessComment({
        commentModel: new ExternalAccessCommentModel({
          singleUseToken: externalAccessData?.singleUseToken,
          message: comment.message,
          attachments: comment.attachments,
        }),
      })
    );
  };

  return (
    <CPLAnalytics pageName="ExternalAccessComment">
      <PageTitle breadcrumbs={externalAccessCommentBreadCrumbs} />
      <ActivityIndicator isBusy={loading}>
        <div className="card mb-6">
          <div className="card-header">
            <div className="card-title">Comment</div>
          </div>
          <div className="card-body">
            {actionSuccessful ? (
              <div>Your comment has been added</div>
            ) : (
              <div>
                <Comment newComment externalAccess handleSave={handleCreateComment} loading={loading} />
              </div>
            )}
          </div>
        </div>
      </ActivityIndicator>
    </CPLAnalytics>
  );
};

export default ExternalAccessCommentPage;
